{
  "id": "theia",
  "pantheon": "atlanteans",
  "name": {
    "pt-BR": "Theia",
    "en": "Theia"
  },
  "icon": "gods/theia",
  "portrait": "gods/theia-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "stymphalian-bird": 1
  },
  "unlocks": [
    "stymphalian-bird",
    "dryad",
    "hesperides-tree",
    "daughters-of-the-sea",
    "prophetic-sight",
    "poseidons-secret",
    "lance-of-stone"
  ],
  "powers": ["hesperides"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml HeroicAgeTheia)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Age-up tech: CreateUnit 1 stymphalian-bird at the Temple (Kronos: +1 from KronosExtra*, so 2). God power HesperidesTree (cooldown 60 s). Hesperides Tree god power: the tree trains Dryads (limit 5) and the cast spawns 2 Dryads."
  }
}
